var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { Frame } from "framer";
import { Subtitle } from "../../designSystem";
import colors from "../../designSystem/colors";
import theme from "../../designSystem/theme";
var PaginationContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
    switch (props.variant) {
        case "buttonLeft":
            return "\n          & :nth-child(1) {\n            order: 1;\n          }\n\n          & :nth-child(2) {\n            order: 3;\n          }\n\n          & :nth-child(3) {\n            order: 4;\n          }\n\n          & :nth-child(4) {\n            order: 5;\n          }\n\n          & :nth-child(5) {\n            order: 2;\n            margin-left: 16px;\n          }\n        ";
    }
    return "";
});
var ArrowButton = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffffff0a;\n  border-radius: 100px;\n  width: 48px;\n  height: 48px;\n  transition: opacity 100ms ease-in;\n\n  ", "\n\n  i {\n    color: white;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #ffffff0a;\n  border-radius: 100px;\n  width: 48px;\n  height: 48px;\n  transition: opacity 100ms ease-in;\n\n  ", "\n\n  i {\n    color: white;\n  }\n"])), function (props) {
    return props.disabled
        ? "\n          opacity: 0.24;\n          cursor: default;\n        "
        : "\n          &:hover {\n            opacity: " + theme.hover.opacity + ";\n          }\n        ";
});
var TotalText = styled(Subtitle)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), colors.text);
var PaginationBar = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 80px;\n  height: 2px;\n  background-color: #ffffff0a;\n  position: relative;\n"], ["\n  width: 80px;\n  height: 2px;\n  background-color: #ffffff0a;\n  position: relative;\n"])));
var Pagination = function (_a) {
    var page = _a.page, total = _a.total, setPage = _a.setPage, variant = _a.variant;
    return total > 0 ? (_jsxs(PaginationContainer, __assign({ className: "d-flex w-100 justify-content-center align-items-center", variant: variant }, { children: [_jsx(ArrowButton, __assign({ role: "button", disabled: page <= 1, onClick: function () {
                    if (page <= 1) {
                        return;
                    }
                    setPage(function (page) { return page - 1; });
                } }, { children: _jsx("i", { className: "fas fa-arrow-left" }, void 0) }), void 0), _jsx(Subtitle, __assign({ className: "ml-5 mr-3" }, { children: String(page).padStart(2, "0") }), void 0), _jsx(PaginationBar, { children: _jsx(Frame, { transition: {
                        type: "keyframes",
                        ease: "easeOut",
                    }, top: 0, left: 0, height: 2, width: 0, backgroundColor: "#FFFFFF", animate: {
                        width: (80 * page) / total,
                    } }, void 0) }, void 0), _jsx(TotalText, __assign({ className: "mr-5 ml-3" }, { children: String(total).padStart(2, "0") }), void 0), _jsx(ArrowButton, __assign({ role: "button", disabled: page >= total, onClick: function () {
                    if (page >= total) {
                        return;
                    }
                    setPage(function (page) { return page + 1; });
                } }, { children: _jsx("i", { className: "fas fa-arrow-right" }, void 0) }), void 0)] }), void 0)) : (_jsx(_Fragment, {}, void 0));
};
export default Pagination;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Pagination.js.map